// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomerSupportBanner_root__vbr__","content":"CustomerSupportBanner_content__3MSn1","title":"CustomerSupportBanner_title__33mh1"};